import React, { FC } from 'react';
import { WithConditionalWrapperHoc } from '../HOC/WithConditionalWrapper/WithConditionalWrapper.hoc';
import AntTooltip, { TooltipProps as AntTooltipProps } from 'antd/lib/tooltip';

type TooltipProps = AntTooltipProps & {
  children?: React.ReactNode;
  when?: boolean;
};

export const Tooltip: FC<TooltipProps> = ({
  children,
  when,
  title,
  ...props
}) => {
  return (
    <WithConditionalWrapperHoc
      useWrapper={!!when}
      wrapper={<AntTooltip color='white' title={title} {...props} />}
    >
      {children}
    </WithConditionalWrapperHoc>
  );
};
